<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <router-link to="/flow/list">
          <el-button>返回</el-button>
        </router-link>
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加分类
        </router-link>
      </div>
      <div class="fl w-200 m-l-30" @keyup.enter="search()">
        <el-input placeholder="请输入分类名" v-model="keywords">
          <el-button slot="append" icon="search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column label="名称" prop="name" width="200">
      </el-table-column>
      <el-table-column label="描述" prop="description">
      </el-table-column>
      <el-table-column label="状态" prop="status" width="100">
        <template scope="scope">
          <div>
            {{ scope.row.status | status }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="200">
        <template scope="scope">
          <div>
            {{ scope.row.create_time | parseTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <div>
            <span v-show="editShow">
              <router-link :to="{ name: 'flowtypeEdit', query: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">
            编辑
              </router-link>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'bpm/types'"></btnGroup>
      <div class="block pages">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="limit" :current-page="currentPage"
          :total="dataCount">
          </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../Common/normal/btn-group.vue'
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        status: '',
        multipleSelection: [],
        statusOption: [
          {
            label: '启用',
            value: 1
          },
          {
            label: '禁用',
            value: 0
          }
        ],
        loading: false,
        limit: 15
      }
    },
    filters: {
      parseTime(item) {
        return moment.unix(item).format('YYYY-MM-DD')
      }
    },
    methods: {
      search() {
        router.push({ name: 'flowtypeList', query: { page: 1, keywords: this.keywords, status: this.status }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ name: 'flowtypeList', query: { page: page, keywords: this.keywords, status: this.status }})
      },
      getAllClassify() {
        this.loading = true
        let postData = {
          params: {
            keywords: this.keywords,
            limit: this.limit,
            page: this.currentPage,
            status: this.status
          }
        }
        this.apiGet('bpm/types', postData).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      init() {
        this.getCurrentPage()
        this.getKeywords()
        this.getAllClassify()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// list.vue?717898f5